import React, { useMemo } from "react";
import { motion } from "framer-motion";
import l from "components/util/l";

function getWords(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = div.textContent || "";
  return text.trim().split(/\s+/).filter(Boolean);
}

const StreamWords = ({ words, showCursor = false }) => (
  <div>
    {words.map((word, index) => (
      <motion.span
        key={index}
        initial={{ opacity: 0, y: 5, filter: "blur(3px)" }}
        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        transition={{ duration: 0.14, ease: "easeOut" }}
        className="thinking-streaming__word"
      >
        {word}{" "}
      </motion.span>
    ))}
    {showCursor && <span className="thinking-streaming__cursor-span" />}
  </div>
);

const ThinkingAnimation = ({ activityText = "", thinkingText = "", outputText = "", isStreaming = false, agentName = "Workix" }) => {

  const thinkingWords = useMemo(() => getWords(thinkingText), [thinkingText]);
  const outputWords = useMemo(() => getWords(outputText), [outputText]);

  if (!isStreaming) return null;

  const hasThinking = thinkingWords.length > 0;
  const hasOutput = outputWords.length > 0;

  return (
    <div className="message thinking-animation">
      <motion.span
        className={"sender-name font-weight-bold w-100 " + (!hasThinking ? "thinking-animation__label" : "")}
        animate={{ backgroundPosition: ["180% 50%", "-80% 50%"] }}
        transition={{ duration: 2.25, repeat: Infinity, repeatDelay: 2.5, ease: "easeInOut" }}
      >
        {agentName} - {activityText || l("Pensando%CH002")}
      </motion.span>

      {hasThinking && (
        <div className="thinking-streaming">
          <StreamWords words={thinkingWords} showCursor={!hasOutput} />
        </div>
      )}

      {hasOutput && (
        <>
          {hasThinking && <div className="thinking-streaming__divider" />}
          <div className="thinking-streaming thinking-streaming--output">
            <StreamWords words={outputWords} showCursor />
          </div>
        </>
      )}
    </div>
  );
};

export default ThinkingAnimation;
